/* eslint-disable react/prop-types */
import React, { useEffect } from 'react'
import Histogram from './Histogram'
import { HistogramState, HistogramEvent } from './types'

const HistogramWidgetController: React.FC<LiveReactChartProps<
    HistogramState,
    FlowMessage<HistogramEvent>,
    DefaultChartConfigs
>> = (props): JSX.Element => {
    const chart = React.useRef<Highcharts.Chart>(null)
    const { state, width, height } = props
    const { legendEnabled, legendRight } = props.widget.jsonConfig
    const { data, historyEnded } = state

    useEffect(() => {
        if (historyEnded) {
            if (!chart.current) return
            if (chart.current.series.length > 0) {
                chart.current.series[0].setData(data as Highcharts.PointOptionsType[], true)

                return
            }

            chart.current.addSeries({ data } as Highcharts.SeriesOptionsType, true)
        }
    }, [data, historyEnded])

    if (!data?.length) return null

    // This widget does not need other properties ?
    // as inverted,  isDatetime, verticalEnabled, xAxisOpposite and xAxisTitle

    return <Histogram chart={chart} width={width} height={height} legendEnabled={legendEnabled} legendRight={legendRight}/>
}

export default HistogramWidgetController
